import { LanguageEnum } from "src/@smartmanufacturing/common/enum";

class Language {
    constructor(
        public id: string = '',
        public name = 'Arabic',
        public isoCode = LanguageEnum.Arabic,
        public isDefault: boolean = false
    ) {
    }
}
export class SharedConstants {
    public static BREADCRUMB = 'breadcrumb';
    public static DEVICE_OS_TYPE_MAC = 'Mac';
    public static INIT_VALUE = 'Init';
    public static NOT_SUPPORTED = 'NOT_SUPPORTED';

    // ERRORS RESPONSE TYPES
    public static NOT_FOUND_ERROR = 404;
    public static SERVER_ERROR = 500;
    public static VALIDATAION_ERROR = 403;
    public static ACCESS_DENIED_ERROR = 403;
    // SUCCESS RESPONSE TYPES
    public static CREATED_SUCCESS = 201;
    public static REQUEST_SUCCESS = 200;

    // STATIC NAVIGATION PATH
    public static PAGE_ERROR = 'error';
    public static PAGE_NOT_FOUND = 'error-404';
    public static ACCESS_DENIED = 'access-denied';


    // STATIC NAVIGATION PATH
    public static ACCOUNT = 'account';
    public static CONFIRM_EMAIL = 'confirm-email';
    public static RESET_PASSWORD = 'reset-password';



    // PUBLIC NAVIGATION PATH
    public static AUTH = 'auth';
    public static SIGN_IN = 'sign-in';
    public static SIGN_OUT = 'sign-out';
    public static FORGOT_PASSWORD = 'forgot-password';

    // PRIVATE Navigation path
    public static DASHBOARD_PATH = 'dashboard';
    public static DASHBOARD_DETAILS_PATH = 'details';
    public static ADVANCE_ANALYTICS = 'advance-analytics';
    public static ADD_DASHBOARD_TARGET = 'add-dashboard-target';
    public static VIEW_DASHBOARD_TARGET = 'view-dashboard-target';
    public static DASHBOARD_FULLSCREEN = "dashboard-fullscreen";

    public static USER_MANAGEMENT = 'user-management';
    public static USERS = 'users';
    public static VIEW_USER = 'view-user';
    public static VIEW_PROFILE = 'view-profile';
    public static ROLES = 'roles';
    public static VIEW_ROLE = 'view-role';
    public static SWITCH_ACCOUNT = 'switch-account';
    public static MULTIPLE_PLANT_REQUESTS = 'multiple-plant-requests';
    public static MULTIPLE_PLANT_REQUEST_VIEW = 'multiple-plant-request-view';
    public static USERS_REQUESTS_SENT = 'users-requests-sent';

    public static DEPARTMENT_SETUP = "department-setup";
    public static DEPARTMENTS = "departments";
    public static DEPARTMENT_VIEW = "department-view";
    public static PLANT_MODELS = "plant-models";
    public static UTILITY_PARAMETERS = "utility-parameters";
    public static SANED_ADMINISTRATION = "saned-administration";

    public static GROUP_SETUP = 'group-setup';
    public static GROUPS = 'groups';
    public static CREATE_EDIT_GROUP = 'create-edit-group';
    public static VIEW_GROUP = 'view-group';

    public static PLANT_SETUP = 'plant-setup';
    public static PLANTS = 'plants';
    public static CREATE_EDIT_PLANT = 'create-edit-plant';
    public static VIEW_PLANT = 'view-plant';

    public static UTILITY_MANAGEMENT = 'utility-management';
    public static PROCESS_READING_INTERVAL = 'process-reading-interval';
    public static UTILITY_CONTROL = 'utility_control';

    // EMPLOYEE PATHS
    public static EMPLOYEE_SETUP = 'employee-setup';
    public static EMPLOYEES = 'employees';
    public static CREATE_EDIT_EMPLOYEE = 'create-edit-employee';
    public static VIEW_EMPLOYEE = 'view-employee';
    // Validations

    public static PHOTOGRAPHY_TYPE_ICON_MAX_HEIGHT = 200;
    public static PHOTOGRAPHY_TYPE_ICON_MAX_WIDTH = 200;

    public static IMAGE_PREVIEW_SIZE_WIDTH = 1280;
    public static IMAGE_PREVIEW_SIZE_HEIGHT = 720;
    public static PLANT_TITLE_MAX_LENGTH = 100;
    public static PLANT_DESCRIPTION_MAX_LENGTH = 450;

    public static UPLOAD_IMAGE_MAX_SIZE_HINT = '5MB';
    public static UPLOAD_IMAGE_MAX_SIZE_KB = 5242880;
    public static UPLOAD_IMAGE_FILE_TYPE = [
        'image/png',
        'image/jpeg',
        'image/jpg',
    ];
    public static UPLOAD_ANY_FILE_TYPE = ['all-files'];
    public static UPLOAD_BULK_USERS_FILE_TYPE = [
        'application/vnd.ms-excel',
        'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet',
        '.csv',
        'text/csv',
    ];

    public static LANGUAGES_NAMES: Language[] = [
        new Language('', 'العربية', LanguageEnum.Arabic),
        new Language('', 'English', LanguageEnum.English),
    ];

    public static ADMIN_ROLES: string[] = ['Group Admin', 'Plant Admin']
}
